import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "as-tab-bar" }
const _hoisted_2 = {
  key: 0,
  class: "as-sort-by"
}
const _hoisted_3 = { class: "as-with-by" }
const _hoisted_4 = {
  key: 1,
  class: "as-statics-scores"
}
const _hoisted_5 = { class: "as-statics-scores__item" }
const _hoisted_6 = { class: "as-number-scores as-score-win" }
const _hoisted_7 = { class: "__win" }
const _hoisted_8 = { class: "as-statics-scores__item" }
const _hoisted_9 = { class: "as-number-scores as-score-win" }
const _hoisted_10 = { class: "__lose" }
const _hoisted_11 = {
  key: 2,
  class: "as-filter-vs"
}
const _hoisted_12 = { class: "as-filter-vs__filter" }
const _hoisted_13 = { class: "as-filter-vs__scores" }
const _hoisted_14 = { class: "__win" }
const _hoisted_15 = { class: "__lose" }
const _hoisted_16 = {
  key: 3,
  class: "as-filter-vs"
}
const _hoisted_17 = { class: "as-filter-vs__filter" }
const _hoisted_18 = { class: "as-filter-vs__scores" }
const _hoisted_19 = { class: "__win" }
const _hoisted_20 = { class: "__lose" }
const _hoisted_21 = { class: "as-h2h as-scrolling as-scrolling__have-tab as-scrolling__result-popup" }
const _hoisted_22 = { class: "as-h2-title-box" }
const _hoisted_23 = { class: "as-h2-title-box" }

import { ref, computed, getCurrentInstance } from "vue";
import H2hTab from "~src/components/h2h/tennis/H2hTab.vue";
import type { IMatchTennis, IH2h } from "~src/interfaces/tennis";
import IconChecked from "~src/components/icons/IconChecked.vue";
import { parseMatchH2hData } from "~src/helpers/tennis";
import TabsBtn from "~src/components/TabsBtn.vue";
import { usecommonStore } from "~src/stores/CommonStore";
import NoData from "~src/components/NoData.vue";
import MatchEnum from "~src/enums/tennis/MatchEnum";
import IConSort from "~src/components/icons/IConSort.vue";
interface IProps {
  h2h: IH2h;
  match: IMatchTennis;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'H2hList',
  props: {
    h2h: {},
    match: {}
  },
  setup(__props: any) {

const commonStore = usecommonStore();

const props = __props;

const instance:any = getCurrentInstance();

const siteName = computed(() => commonStore.getSiteName);
const activeTab = ref("vs");
const filterGround = ref(null);
const filterIsHomeGround = ref(false);
const filterIsThisSession = ref(false);
const _winHome = ref(0);
const _losesHome = ref(0);
const _winAway = ref(0);
const _losesAway = ref(0);

const filterIsSingles = ref(
  (props.match.away_team?.sub_ids?.length || 0) > 0 &&
    (props.match.home_team?.sub_ids?.length || 0) > 0
    ? false
    : true
);

const tabs = ref([
  {
    title: props.match.home_team.short_name_vi || props.match.home_team.name,
    key: "home",
  },
  {
    title: "Toàn bộ",
    key: "vs",
  },
  {
    title: props.match.away_team.short_name_vi || props.match.away_team.name,
    key: "away",
  },
]);

const changeTab = (val: string) => {
  activeTab.value = val;
};

const _getWinsLoses = (data: any[] = [], mode: string = "win") => {
  let number = 0;

  if (data) {
    data.forEach((item: any) => {
      const __item = parseMatchH2hData(item, props.match.home_team?.id);
      if (
        (__item?.match_time_player as { text: string; status_h2h: string })
          ?.status_h2h === mode
      ) {
        number += 1;
      }
    });
  }

  return number;
};

const groundId = computed(() => {
  return props.match.tournament?.ground_id ?? 0;
});

const groundType = computed(() => {
  const groundTypeText = MatchEnum.GROUND_TYPE_STTAUS as Record<number, string>;
  const ground_id = groundId.value;
  return groundTypeText[ground_id] ?? "";
});

const items = ref(6);
const isShowMoreVs = ref(0);
const isShowMoreHome = ref(0);
const isShowMoreAway = ref(0);

const handleShowMore = (_mode: string) => {
  if (_mode === "vs") {
    isShowMoreVs.value = 2;
  } else if (_mode === "home") {
    isShowMoreHome.value = 2;
  } else if (_mode === "away") {
    isShowMoreAway.value = 2;
  }
};

const tournaments = computed(() => {
  if (instance?.proxy?.gSportType === "volleyball") {
    return props.h2h?.uniqueTournaments ?? [];
  }

  return props.h2h?.tournaments ?? [];
});

const h2hVs = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.vs)) {
    return [];
  }

  const data = props.h2h.vs.filter((item: any) => {
    let check = true;
    if (check && activeTab.value === "home") {
      check = props.match.home_team?.id === item.home_team_id;
    }

    if (check && activeTab.value === "away") {
      check = props.match.away_team?.id === item.away_team_id;
    }

    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }

    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check =
            item.home_team.sub_ids.length === 0 &&
            item.away_team.sub_ids.length === 0;
        } else {
          check =
            item.home_team.sub_ids.length > 0 &&
            item.away_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  let _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });

  if (isShowMoreVs.value != 2) {
    isShowMoreVs.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreVs.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});

const h2hHome = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.home)) {
    return [];
  }

  const data = props.h2h.home.filter((item: any) => {
    let check = true;

    if (check && activeTab.value === "home") {
      check =
        props.match.home_team_id === item.home_team_id ||
        props.match.home_team_id === item.away_team_id;
    }

    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }
    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsHomeGround.value) {
          check = props.match.home_team_id === item.home_team_id;
        }

        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check = item.home_team.sub_ids.length === 0;
        } else {
          check = item.home_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  const _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });
  _winHome.value = _getWinsLoses(_data, "win");
  _losesHome.value = _getWinsLoses(_data, "lose");

  if (isShowMoreHome.value != 2) {
    isShowMoreHome.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreHome.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});

const h2hAway = computed(() => {
  if (!props.h2h || !Array.isArray(props.h2h.away)) {
    return [];
  }

  const data = props.h2h.away.filter((item: any) => {
    let check = true;
    if (check && activeTab.value === "away") {
      check =
        props.match.away_team_id === item.away_team_id ||
        props.match.away_team_id === item.home_team_id;
    }
    if (
      check &&
      filterGround.value !== null &&
      filterGround.value !== undefined
    ) {
      check = item.tournament.ground_id === filterGround.value;
    }
    if (check) {
      if (instance?.proxy?.gSportType === "volleyball") {
        if (filterIsHomeGround.value) {
          check = props.match.home_team_id === item.away_team_id;
        }

        if (filterIsThisSession.value) {
          check =
            props.match.unique_tournament_id === item.unique_tournament_id;
        }
      } else {
        if (filterIsSingles.value) {
          check = item.away_team.sub_ids.length === 0;
        } else {
          check = item.away_team.sub_ids.length > 0;
        }
      }
    }

    return check;
  });

  let _data = data.sort((a: any, b: any) => {
    return a.match_time > b.match_time ? -1 : 1;
  });

  _winAway.value = _getWinsLoses(_data, "win");
  _losesAway.value = _getWinsLoses(_data, "lose");

  if (isShowMoreAway.value != 2) {
    isShowMoreAway.value = _data.length > 6 ? 1 : 0;
  }

  if (isShowMoreAway.value == 2) {
    return _data;
  }

  return _data.slice(0, items.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`as-parent-h2h as-parent-h2h__item-h-auto as-parent-h2h-${siteName.value}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(TabsBtn, {
        tabs: tabs.value,
        activeTab: activeTab.value,
        onChange: changeTab,
        isShowBorder: true
      }, null, 8, ["tabs", "activeTab"])
    ]),
    (_ctx.gSportType === 'badminton')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (filterIsSingles.value = !filterIsSingles.value))
          }, [
            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "as-title" }, " Sắp xếp: ", -1)),
            _createElementVNode("span", _hoisted_3, _toDisplayString(filterIsSingles.value ? "Đánh đơn" : "Đánh đội"), 1),
            _createVNode(IConSort)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.gSportType === 'badminton')
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "__title" }, "Thắng", -1)),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("span", _hoisted_7, _toDisplayString(activeTab.value === "home"
                ? _winHome.value
                : activeTab.value === "away"
                ? _winAway.value
                : activeTab.value === "vs"
                ? _winHome.value + _winAway.value
                : 0), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _cache[10] || (_cache[10] = _createElementVNode("span", { class: "__title" }, "Thua", -1)),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(activeTab.value === "home"
                ? _losesHome.value
                : activeTab.value === "away"
                ? _losesAway.value
                : activeTab.value === "vs"
                ? _losesHome.value + _losesAway.value
                : 0), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.gSportType == 'tennis')
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", {
              class: "as-button-filter",
              role: "button",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (filterGround.value = filterGround.value === groundId.value ? null : groundId.value))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(filterGround.value === groundId.value ? 'as-checked' : 'as-none'),
                role: "button"
              }, [
                (filterGround.value == groundId.value)
                  ? (_openBlock(), _createBlock(IconChecked, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _createElementVNode("span", null, _toDisplayString(groundType.value), 1)
            ]),
            _createElementVNode("div", {
              class: "as-button-filter",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (filterIsSingles.value = !filterIsSingles.value))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(filterIsSingles.value ? 'as-checked' : 'as-none'),
                role: "button"
              }, [
                (filterIsSingles.value)
                  ? (_openBlock(), _createBlock(IconChecked, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _cache[11] || (_cache[11] = _createElementVNode("span", null, "Đánh đơn", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "__title" }, "Thắng:", -1)),
              _createElementVNode("span", _hoisted_14, _toDisplayString(activeTab.value === "home"
                ? _winHome.value
                : activeTab.value === "away"
                ? _winAway.value
                : activeTab.value === "vs"
                ? _winHome.value + _winAway.value
                : 0), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[13] || (_cache[13] = _createElementVNode("span", { class: "__title" }, "Thua:", -1)),
              _createElementVNode("span", _hoisted_15, _toDisplayString(activeTab.value === "home"
                ? _losesHome.value
                : activeTab.value === "away"
                ? _losesAway.value
                : activeTab.value === "vs"
                ? _losesHome.value + _losesAway.value
                : 0), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.gSportType == 'volleyball')
      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("div", {
              class: "as-button-filter",
              role: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (filterIsHomeGround.value = !filterIsHomeGround.value))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(filterIsHomeGround.value ? 'as-checked' : 'as-none'),
                role: "button"
              }, [
                (filterIsHomeGround.value)
                  ? (_openBlock(), _createBlock(IconChecked, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _cache[14] || (_cache[14] = _createElementVNode("span", null, "Sân nhà", -1))
            ]),
            _createElementVNode("div", {
              class: "as-button-filter",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (filterIsThisSession.value = !filterIsThisSession.value))
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(filterIsThisSession.value ? 'as-checked' : 'as-none'),
                role: "button"
              }, [
                (filterIsThisSession.value)
                  ? (_openBlock(), _createBlock(IconChecked, { key: 0 }))
                  : _createCommentVNode("", true)
              ], 2),
              _cache[15] || (_cache[15] = _createElementVNode("span", null, "Mùa giải này", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", null, [
              _cache[16] || (_cache[16] = _createElementVNode("span", { class: "__title" }, "Thắng:", -1)),
              _createElementVNode("span", _hoisted_19, _toDisplayString(activeTab.value === "home"
                ? _winHome.value
                : activeTab.value === "away"
                ? _winAway.value
                : activeTab.value === "vs"
                ? _winHome.value + _winAway.value
                : 0), 1)
            ]),
            _createElementVNode("div", null, [
              _cache[17] || (_cache[17] = _createElementVNode("span", { class: "__title" }, "Thua:", -1)),
              _createElementVNode("span", _hoisted_20, _toDisplayString(activeTab.value === "home"
                ? _losesHome.value
                : activeTab.value === "away"
                ? _losesAway.value
                : activeTab.value === "vs"
                ? _losesHome.value + _losesAway.value
                : 0), 1)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _withDirectives(_createElementVNode("div", null, [
      _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "as-h2-title-box" }, "Các trận đối đầu", -1)),
      (h2hVs.value.length)
        ? (_openBlock(), _createBlock(H2hTab, {
            h2h: h2hVs.value,
            teams: _ctx.h2h.teams,
            competitions: tournaments.value,
            match: _ctx.match,
            tab: "all",
            homeTeamId: _ctx.match.home_team_id,
            key: activeTab.value,
            isShowMore: isShowMoreVs.value,
            mode: "vs",
            onHandleIsShowMore: _cache[5] || (_cache[5] = (newVal = 'vs') => handleShowMore(newVal))
          }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId", "isShowMore"]))
        : (_openBlock(), _createBlock(NoData, {
            key: 1,
            modifyClass: "as-h-50"
          }))
    ], 512), [
      [_vShow, activeTab.value === 'vs']
    ]),
    _createElementVNode("div", _hoisted_21, [
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_22, " Các trận gần nhất: " + _toDisplayString(_ctx.match.home_team.name), 1),
        (h2hHome.value.length)
          ? (_openBlock(), _createBlock(H2hTab, {
              h2h: h2hHome.value,
              teams: _ctx.h2h.teams,
              competitions: tournaments.value,
              match: _ctx.match,
              tab: "home",
              homeTeamId: _ctx.match.home_team_id,
              key: activeTab.value,
              isShowMore: isShowMoreHome.value,
              mode: "home",
              onHandleIsShowMore: _cache[6] || (_cache[6] = (newVal = 'home') => handleShowMore(newVal))
            }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId", "isShowMore"]))
          : (_openBlock(), _createBlock(NoData, {
              key: 1,
              modifyClass: "as-h-50"
            }))
      ], 512), [
        [_vShow, activeTab.value !== 'away']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("h2", _hoisted_23, " Các trận gần nhất: " + _toDisplayString(_ctx.match.away_team.name), 1),
        (h2hAway.value.length)
          ? (_openBlock(), _createBlock(H2hTab, {
              h2h: h2hAway.value,
              teams: _ctx.h2h.teams,
              competitions: tournaments.value,
              match: _ctx.match,
              tab: "away",
              homeTeamId: _ctx.match.away_team_id,
              key: activeTab.value,
              isShowMore: isShowMoreAway.value,
              mode: "away",
              onHandleIsShowMore: _cache[7] || (_cache[7] = (newVal = 'away') => handleShowMore(newVal))
            }, null, 8, ["h2h", "teams", "competitions", "match", "homeTeamId", "isShowMore"]))
          : (_openBlock(), _createBlock(NoData, {
              key: 1,
              modifyClass: "as-h-50"
            }))
      ], 512), [
        [_vShow, activeTab.value !== 'home']
      ])
    ])
  ], 2))
}
}

})